/**
 * Profitability calculation utilities to ensure consistency between frontend and backend
 *
 * Backend stores profitability as cents (30% = 3000)
 * Frontend displays as percentage (30% = 30)
 */

export const convertProfitabilityToCents = (profitabilityPercentage: number): number => {
  return Math.round(profitabilityPercentage * 100)
}

export const convertCentsToPercentage = (profitabilityCents: number): number => {
  return profitabilityCents / 100
}

export const calculateProfitabilityPercentage = (costRate: number, billRate: number): string => {
  if (costRate === 0) return '0'

  const profitMargin = ((billRate - costRate) / costRate) * 100
  return profitMargin.toFixed(2)
}

export const calculateBillRateFromProfitability = (
  costRate: number,
  profitabilityPercentage: number
): string => {
  if (costRate === 0) return '0'

  const calculatedBillRate = costRate + (costRate * profitabilityPercentage) / 100
  return calculatedBillRate.toFixed(2)
}
